import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {debounce} from 'lodash';

import {initializeSearch, searchInputBlur, searchInputDirty, searchInputFocus, toggleFilterDisplay} from '../actions';
import {isFilterOpen, isInputFocused, isPristine} from '../selectors';

import SearchMultiSelect from './SearchMultiSelect';
import SearchForm from './SearchForm';

const formName = "searchForm";

class SearchPanel extends React.Component {
  componentWillMount() {
    this.props.actions.initializeSearch();
  }

  handleInputChange = (values) => {
    if(this.props.isPristine && values.searchPhrase !== undefined) {
      this.props.actions.searchInputDirty();
    }

    if(!this.props.isPristine) {
      this.props.onSubmit(values);
    }
    
    return {};
  }

  render() {
    const {actions, filterOpen, inputFocus, itemList, onSelectedItem, onSubmit, selectedItems} = this.props;
    const asyncInput = debounce((values) => {this.handleInputChange(values);}, 250);

    return (
      <div className="input-group search">
        <SearchMultiSelect isOpen={filterOpen}
                           itemList={itemList.sort()}
                           onSelected={onSelectedItem}
                           onToggle={actions.toggleFilterDisplay}
                           selectedItems={selectedItems}/>
        <SearchForm form={formName} 
                    hasFocus={inputFocus}
                    onBlur={actions.searchInputBlur} 
                    onFocus={actions.searchInputFocus}
                    onSubmit={onSubmit}
                    validate={asyncInput}/>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    filterOpen: isFilterOpen(state),
    inputFocus: isInputFocused(state),
    isPristine: isPristine(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({initializeSearch, searchInputBlur, searchInputDirty, searchInputFocus, toggleFilterDisplay}, dispatch)
  };
}

SearchPanel.propTypes = {
  actions: PropTypes.object.isRequired,
  filterOpen: PropTypes.bool.isRequired,
  inputFocus: PropTypes.bool.isRequired,
  isPristine: PropTypes.bool.isRequired,
  itemList: PropTypes.array.isRequired,
  onSelectedItem: PropTypes.func.isRequired,
	onSubmit: PropTypes.func.isRequired,
  selectedItems: PropTypes.array.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPanel);


/** WEBPACK FOOTER **
 ** ./src/modules/search/components/SearchPanel.js
 **/